import React from 'react';
import './Toggle.css';

// The portal's on/off switch.
//
// A LABELLED PILL, not a bare slider: the state is written inside the control and the control is tinted
// by it, so nobody has to infer "on" from a colour they cannot see the other half of. See Toggle.css for
// why, and STYLE.md for when to use it.
//
// THE LABEL SAYS WHAT IS TRUE, NOT WHAT CLICKING DOES. "Active" on a switch that is on; the title
// attribute carries "Click to deactivate". A control labelled with its action reads, at a glance, as a
// report of the state it is about to leave.
//
// `busy` replaces the label with "Saving…" and disables it, because these switches write immediately —
// there is no Save button to show progress on.
//
// NO CAPTION BESIDE IT, EVER. An explanatory word hung off the end of the pill collides with whatever
// sits under it and reads as a second control; if a state needs explaining, the label is where it goes
// ("Not restricted", not "Any address" plus a warning).
const Toggle = ({
    on,
    onChange,
    onLabel = 'On',
    offLabel = 'Off',
    busy = false,
    disabled = false,
    size,                       // 'sm' for a table row or a card header
    title,
    className = '',
}) => (
    <button
        type="button"
        className={`hc-toggle ${on ? 'hc-toggle-on' : 'hc-toggle-off'}`
            + `${size === 'sm' ? ' hc-toggle-sm' : ''}${className ? ` ${className}` : ''}`}
        onClick={() => !busy && !disabled && onChange(!on)}
        disabled={busy || disabled}
        title={title || (on ? 'Click to turn off' : 'Click to turn on')}
        aria-pressed={!!on}
    >
        <span className="hc-toggle-track"><span className="hc-toggle-thumb" /></span>
        <span className="hc-toggle-label">{busy ? 'Saving…' : (on ? onLabel : offLabel)}</span>
    </button>
);

export default Toggle;
